import { getDatahubMatch, getIDQMatch, getSonwinMatch } from "../../Services/ApiService";
import ApiResponseModel from "../../Models/ApiResponseModel";

export const shouldBypassDatahubValidation = (
	nodeEnv: string | undefined = process.env.NODE_ENV,
	bypassFlag: string | undefined = process.env.REACT_APP_BYPASS_DATAHUB_VALIDATION
): boolean => nodeEnv === "development" && bypassFlag === "true";

const getDatahubMatchForValidation = (fullName: string, datahubAddress: any) => {
	if (!shouldBypassDatahubValidation()) {
		return getDatahubMatch(fullName, datahubAddress);
	}

	return Promise.resolve({
		isSuccessful: true,
		status: 200,
		data: { validationResult: "Valid" },
	} as ApiResponseModel);
};

const ValidateUserProfile = async (
	cpr: string,
	fullName: string,
	datahubAddress: any,
	deliveryAddressId: string,
	resolveValidation: any,
	cohabStep: boolean,
	company: string
) => {
	if (!cohabStep) {
		await Promise.allSettled([
			getIDQMatch(cpr, fullName),
			getDatahubMatchForValidation(fullName, datahubAddress),
			getSonwinMatch(deliveryAddressId, company),
		]).then((result) => {
			let iDQResult = result[0];
			let datahubResult = result[1];
			let sonwinResult = result[2];
			resolveValidation(iDQResult, datahubResult, sonwinResult);
		});
	} else {
		await Promise.allSettled([
			getIDQMatch(cpr, fullName),
			getDatahubMatchForValidation(fullName, datahubAddress),
		]).then((result) => {
			let iDQResult = result[0];
			let datahubResult = result[1];
			resolveValidation(iDQResult, datahubResult);
		});
	}
};
export { ValidateUserProfile };
